export default __webpack_public_path__ + "static/footer_1-7ab2d3ca344d791b1dde3f89869dd75f.png";